import { positionHeaderPopover } from '@/helper/headerPopoverPosition';

export default {
  data() {
    return {
      hoverPopover: {
        active: false,
        type: null,
        user: null,
        group: null,
        placement: 'top',
        style: {
          top: '0px',
          left: '0px',
        },
      },
      hoverPopoverShowTimer: null,
      hoverPopoverHideTimer: null,
    };
  },
  beforeDestroy() {
    this.clearHoverPopoverTimers();
  },
  methods: {
    clearHoverPopoverTimers() {
      if (this.hoverPopoverShowTimer != null) {
        clearTimeout(this.hoverPopoverShowTimer);
        this.hoverPopoverShowTimer = null;
      }
      if (this.hoverPopoverHideTimer != null) {
        clearTimeout(this.hoverPopoverHideTimer);
        this.hoverPopoverHideTimer = null;
      }
    },

    cancelHideHoverPopover() {
      if (this.hoverPopoverHideTimer != null) {
        clearTimeout(this.hoverPopoverHideTimer);
        this.hoverPopoverHideTimer = null;
      }
    },

    hideHoverPopover() {
      this.clearHoverPopoverTimers();
      this.hoverPopover.active = false;
      this.hoverPopover.type = null;
      this.hoverPopover.user = null;
      this.hoverPopover.group = null;
      this.hoverPopover.placement = 'top';
    },

    positionHoverPopover(anchorEl) {
      const { placement, style } = positionHeaderPopover(anchorEl);
      this.hoverPopover.placement = placement;
      this.hoverPopover.style = style;
    },

    showUserHoverPopover(e, user) {
      if (!user) {
        return;
      }
      const anchorEl = e && e.currentTarget ? e.currentTarget : e && e.target;
      if (!anchorEl) {
        return;
      }
      this.cancelHideHoverPopover();
      this.hoverPopover.active = true;
      this.hoverPopover.type = 'user';
      this.hoverPopover.user = user;
      this.hoverPopover.group = null;
      this.positionHoverPopover(anchorEl);
    },

    showGroupHoverPopover(e, group) {
      if (!group) {
        return;
      }
      const anchorEl = e && e.currentTarget ? e.currentTarget : e && e.target;
      if (!anchorEl) {
        return;
      }
      this.cancelHideHoverPopover();
      this.hoverPopover.active = true;
      this.hoverPopover.type = 'group';
      this.hoverPopover.group = group;
      this.hoverPopover.user = null;
      this.positionHoverPopover(anchorEl);
    },

    scheduleShowUserHoverPopover(e, user) {
      this.clearHoverPopoverTimers();
      this.hoverPopoverShowTimer = setTimeout(() => {
        this.hoverPopoverShowTimer = null;
        this.showUserHoverPopover(e, user);
      }, 140);
    },

    scheduleShowGroupHoverPopover(e, group) {
      this.clearHoverPopoverTimers();
      this.hoverPopoverShowTimer = setTimeout(() => {
        this.hoverPopoverShowTimer = null;
        this.showGroupHoverPopover(e, group);
      }, 140);
    },

    scheduleHideHoverPopover() {
      this.cancelHideHoverPopover();
      if (this.hoverPopoverShowTimer != null) {
        clearTimeout(this.hoverPopoverShowTimer);
        this.hoverPopoverShowTimer = null;
      }
      this.hoverPopoverHideTimer = setTimeout(() => {
        this.hoverPopoverHideTimer = null;
        this.hideHoverPopover();
      }, 120);
    },

    isHoverPopoverRelatedTarget(relatedTarget) {
      if (!relatedTarget || !relatedTarget.closest) {
        return false;
      }
      return !!(
        relatedTarget.closest('.user-info-wrapper')
        || relatedTarget.closest('.group-info-wrapper')
        || relatedTarget.closest('.feed-hover-popover')
      );
    },

    onHoverPopoverAnchorLeave(e) {
      if (this.isHoverPopoverRelatedTarget(e.relatedTarget)) {
        return;
      }
      this.scheduleHideHoverPopover();
    },

    onPostHeaderMouseover(e) {
      if (e.target.classList.contains('userPopoverName')) {
        this.scheduleShowUserHoverPopover(e, this.userPost);
        return;
      }
      if (e.target.classList.contains('groupPopoverName')) {
        this.scheduleShowGroupHoverPopover(e, this.group);
      }
    },

    onTaggedUserMouseover({ event, user }) {
      if (event && event.target && event.target.classList.contains('userPopoverName')) {
        this.scheduleShowUserHoverPopover(event, user);
      }
    },
  },
};
